import { useTranslation } from 'react-i18next';
import getViewType from 'View/host-schedule/helper/getViewType';

const useGetHeaderTitle = () => {
  const { t } = useTranslation('host-schedule');
  const type = getViewType();

  switch (type) {
    case 'scheduled':
      return t('page.scheduled');
    case 'upcoming':
      return t('page.upcoming');
    case 'past':
      return t('page.completed');
    default:
      return '';
  }
};

export default useGetHeaderTitle;
